/**
 * Members Rewards landing — FAQ accordion (delegated).
 */
(function () {
  function initMrFaqDelegation() {
    if (document.body.dataset.mrFaqDelegation === "1") return;
    document.body.dataset.mrFaqDelegation = "1";
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var faqBtn = t.closest("[data-mr-faq-q]");
      if (!faqBtn || !faqBtn.closest("[data-mr-faq]")) return;
      e.preventDefault();
      var faqRoot = faqBtn.closest("[data-mr-faq]");
      if (!faqRoot) return;
      var ans = faqBtn.nextElementSibling;
      var open = faqBtn.getAttribute("aria-expanded") === "true";
      faqRoot.querySelectorAll("[data-mr-faq-q]").forEach(function (q) {
        q.setAttribute("aria-expanded", "false");
        var a = q.nextElementSibling;
        if (a) a.setAttribute("hidden", "");
      });
      if (!open && ans) {
        faqBtn.setAttribute("aria-expanded", "true");
        ans.removeAttribute("hidden");
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMrFaqDelegation);
  } else {
    initMrFaqDelegation();
  }
})();
